import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { HomeComponent } from "./home/home.component";
import { ConsultaPublicaComponent } from "./consulta-publica/consulta-publica.component";
import { LoginGuard } from "../core/login.guard";

const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'consulta-publica',
    component: ConsultaPublicaComponent
  }
]

@NgModule({
  imports: [
    RouterModule.forChild(routes,)
  ],
  exports: [
    RouterModule
  ]
})
export class HomeRoutingModule {

}